export function updateSwiperStatus(swiper) {
  const statusEl = swiper.el.querySelector('.swiper-status') || swiper.el.querySelector('.js-slider-status');
  if (!statusEl) return;

  const total = swiper.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate')).length;
  const current = swiper.realIndex + 1;

  const message = (window.Shopify?.locale || 'uk') === 'uk'
    ? `Слайд ${current} з ${total}`
    : `Слайд ${current} из ${total}`;

  statusEl.textContent = message;
}

export function updateSlidesInert(swiper, mode = 'visible') {
  swiper.slides.forEach((slide, index) => {
    const isActive =
      mode === 'active'
        ? index === swiper.activeIndex
        : slide.classList.contains('swiper-slide-visible');

    if (isActive) {
      slide.removeAttribute('inert');
      slide.removeAttribute('aria-hidden');
    } else {
      slide.setAttribute('inert', '');
      slide.setAttribute('aria-hidden', 'true');
    }
  });
}